import { FaApple, FaGooglePlay } from 'react-icons/fa';

export const FaAppleIcon = FaApple as React.ComponentType<{
  size?: number;
  color?: string;
}>;

export const FaGooglePlayIcon = FaGooglePlay as React.ComponentType<{
  size?: number;
  color?: string;
}>;
